// extracted by mini-css-extract-plugin
export var entryContainer = "styles-module--entryContainer--D49b6";
export var img = "styles-module--img--bvhHk";
export var teamMemberName = "styles-module--teamMemberName--gMWSB";
export var teamMemberOverlay = "styles-module--teamMemberOverlay--yeywA";
export var teamMemberWrapper = "styles-module--teamMemberWrapper--oSffJ";
export var text = "styles-module--text--qqsiT";
export var textContainer = "styles-module--textContainer--FAq8A";
export var textWrapper = "styles-module--textWrapper--94g6-";